import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useReportTemplates() {
  const [reportTemplates, setReportTemplates] = useState(null);

  const [shouldRefetch, refetch] = useState({});

  useEffect(() => {
    axios
      .get(routes.api.report_templates.index)
      .then((response) => {
        setReportTemplates(response.data.data);
      });
  }, [shouldRefetch]);

  return [reportTemplates, refetch];
}
